module.exports = __webpack_public_path__ + "static/img/mp1.b7566e08.jpg";